import { render } from "./ProfileReport.vue?vue&type=template&id=ec4d367e&scoped=true"
import script from "./ProfileReport.vue?vue&type=script&lang=js"
export * from "./ProfileReport.vue?vue&type=script&lang=js"

import "./ProfileReport.vue?vue&type=style&index=0&id=ec4d367e&lang=scss&scoped=true"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec4d367e"]])

export default __exports__